module.exports = __webpack_public_path__ + "static/img/cabinet24_23.1c46cbec.gif";